import _ from "lodash";
import React, { useContext } from "react";
import { useSelector } from "react-redux";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import {
  getApplicationDTO,
  getHolderData,
  getHolderList,
  getIsKycProcessCompleted,
  getWidgetDTOList,
} from "../../../Store/WidgetDataSelector";
import { WidgetEnum } from "../../../Store/WidgetEnum";
import { EntityTypeEnum } from "./../../../Store/EntityTypeEnum";
import BankAccountVerificationForm from "../../Forms/BankAccountVerificationForm";
import NomineeDetailsForm from "../../Forms/NomineeDetailsForm";
import PersonalInfoForm from "../../Forms/PersonalInfoForm";
import VideoKYCForm from "../../Forms/VideoKYCForm";
import { useWidgetService } from "./UseWidgetService";
import Preview from "../ESignAndTermsAndConditions/Preview";
import ESigningTermsAndConditionsForm from "../../Forms/ESigningTermsAndConditionsForm";


function WidgetManager(props) {
  const applicationContext = useContext(KycApplicationContext);
  const currentHolder = applicationContext.currentHolder;
  const isEmptyList = _.isEmpty(currentHolder?.kycApplicationWorkflowDTOList);

  const currentWidget = applicationContext.currentWidget;
  const {saveWidgetData, saveWidgetDataToDraft, updateWidgetStoreData, completeKyc, dispatchApplicationDetailsToStore,checkFirstHolderHasVideoKYC,checkSecondHolderHasVideoKYC} = useWidgetService();
  const disableForm = applicationContext.disableForm;

  const holderData = useSelector((state) =>
    getHolderData(state, currentHolder ? currentHolder.entityTypeShortName : "")
  );

  const applicationDTO = useSelector((state) =>
    getApplicationDTO(state)
  );

  let widgetList = useSelector((state) =>
    getWidgetDTOList(
      state,
      currentHolder ? currentHolder.entityTypeShortName : ""
    )
  );

  let isKycProcessCompleted = useSelector((state) =>
  getIsKycProcessCompleted(state));

  let holderList = useSelector((state) =>getHolderList(state));


  function _renderWidget(currentWidget) {

    if ((!_.isEmpty(currentWidget)) && !isEmptyList) {
      switch (currentWidget.widgetShortName) {
        case WidgetEnum.PERSONALINFO:
          return (
            <PersonalInfoForm
              value={holderData}
              onSubmit={handleWidgetSubmit}
              onNext={handleWidgetNext}
              onSaveToStore={handleSaveToStore}
              onChange={props.onChange}
              getApplicationDetails = {props.getApplicationDetails}
              setIsLoadingData = {props.setIsLoadingData}
            />
          );
        case WidgetEnum.NOMINEE:
          return (
            <NomineeDetailsForm
              value={holderData}
              onSubmit={handleWidgetSubmit}
              onNext={handleWidgetNext}
              onBack={handleWidgetBack}
              onSaveToStore={handleSaveToStore}
              onChange={props.onChange}
            />
          );
        case WidgetEnum.BANKVF:
          return (
            <BankAccountVerificationForm
              value={holderData}
              onSubmit={handleWidgetSubmit}
              onNext={handleWidgetNext}
              onBack={handleWidgetBack}
              onChange={props.onChange}
            />
          );
        case WidgetEnum.VIDEOKYC:
          return (
            <VideoKYCForm
              value={holderData}
              onSubmit={handleWidgetSubmit}
              onNext={handleWidgetNext}
              onBack={handleWidgetBack}
              onChange={props.onChange}
              moveToWidget={moveToWidgetWithData}
              moveNextWidgetByName = {moveNextWidgetByName}
            />
          );
          case WidgetEnum.PVIEWCKYC:
            return (
              <Preview
                 onBack={handleWidgetBack}
                onCompleteKYC={handleCompleteKYC}                
                onNext={handleWidgetSubmit}
	              isPreview = {true}
                accordionkey={"0"}
              />
            );
	        case WidgetEnum.ESIGNTC:
            return (
              <ESigningTermsAndConditionsForm
                onBack={handleWidgetBack}
                onNext={handleWidgetSubmit}
              />
            );
        default:
          return <div>Not Found</div>;
      }
    }
  }

  /** save widet data and update in the store */
  const handleWidgetNext = (data, currentTabName,suppressSuccessToast) => {

    let saveWidgetPromise = new Promise(function (onSuccess, onError) {
      // if disable form then move the next widget otherwise save and move to next widget
      if(disableForm){
        onSuccess(data);
      }else{
        props.showLoading(true);
        saveWidgetDataToDraft(data, currentHolder, currentWidget,widgetList,currentTabName,suppressSuccessToast).then(
          (response) => {
            props.showLoading(false);
            onSuccess(response);
          },
          (error) => {
            props.showLoading(false);
            onError(error);
          }
        );
      }
      
    });

    return saveWidgetPromise;

   
  }; 

  /** save widget data and update in the store and move to previous widget */
  const handleWidgetBack = (data) => {
    let saveWidgetPromise = new Promise(function (onSuccess, onError) {
      moveToPreviousWidget();
      onSuccess();
    });

    return saveWidgetPromise;
  };

    /** move to given widget */
    const moveToWidgetWithData = (KycApplicationDTO, widgetShortName) => {
      //get the widget and move to the widget
      var currentWidget= moveNextWidgetByName(widgetShortName);
      //set move to holder on application context
      applicationContext.setMoveToHolder(currentHolder.entityTypeShortName);
      //update the application dto
      let saveWidgetPromise = new Promise(function (onSuccess, onError) {
        dispatchApplicationDetailsToStore(KycApplicationDTO);
        onSuccess();
      });
  
      return saveWidgetPromise;
    };

  /** save widget data and update in the store */
  const handleSaveToStore = (data) => {
    let saveWidgetPromise = new Promise(function (onSuccess, onError) {
      updateWidgetStoreData(data, currentHolder, currentWidget,widgetList,isKycProcessCompleted);
      onSuccess();
    });

    return saveWidgetPromise;
  };

  /** save widget data and update in the store */
  const handleWidgetSubmit = (data) => {
    let saveWidgetPromise = new Promise(function (onSuccess, onError) {
      // if disable form then move the next widget otherwise save and move to next widget
      if(disableForm){
        moveToNextWidget(null);
        onSuccess(data);
      }else{
        props.showLoading(true);
        saveWidgetData(data, currentHolder, currentWidget,widgetList).then(
          (response) => {
            props.showLoading(false);
            moveToNextWidget(response);
            onSuccess(response);
          },
          (error) => {
            props.showLoading(false);
            onError(error);
          }
        );
      }
      
    });

    return saveWidgetPromise;
  };

    /** complete KYC and update in the store */
    const handleCompleteKYC = (data) => {
      let saveWidgetPromise = new Promise(function (onSuccess, onError) {
        if(disableForm){
          moveToNextWidget(null);
          onSuccess(data);
        }else{
        props.showLoading(true);
          completeKyc(data, currentHolder, currentWidget,widgetList).then(
          (response) => {
            props.showLoading(false);
            //moveToNextWidget();
            onSuccess(response);
          },
          (error) => {
            props.showLoading(false);
            onError(error);
          }
        );
        }
      });
  
      return saveWidgetPromise;
    };

  const moveToNextWidget = (response) => {
    //check application type as single holder move to next widget otherwise based on condition move to the next widget
    if(applicationDTO.kycAccountTypeShortName==='INDI'){
      moveNextWidget(response);
    }else{
      if(currentHolder.entityTypeShortName === EntityTypeEnum.FH){
        moveToNextWidgetForFirstHolder(response);
      }else{
        moveToNextWidgetForSecondHolder(response);
      }

    }
  };


  const moveToNextWidgetForFirstHolder = (response) => {
    var moveToSecondHolderWidgetName = null;
    switch (currentWidget.widgetShortName) {
      case WidgetEnum.BANKVF:
        if (!isKycProcessCompleted) {
          moveToSecondHolderWidgetName = WidgetEnum.PERSONALINFO;
        }
        break;
      case WidgetEnum.ESIGNTC:
        moveToSecondHolderWidgetName = WidgetEnum.ESIGNTC;
        break;
      case WidgetEnum.VIDEOKYC:
        if (checkSecondHolderHasVideoKYC()){
          moveToSecondHolderWidgetName = WidgetEnum.VIDEOKYC;
        }
   
        break;
      default:
        break;
    }

    if (moveToSecondHolderWidgetName) {
      applicationContext.setCurrentWidget(null);
      setTimeout(() => {
        applicationContext.setWidgetShortNameToShow(moveToSecondHolderWidgetName);
        applicationContext.setCurrentHolder(
          getHolderDataByType(EntityTypeEnum.SH)
        );
      }, 5);
     
    } else {
      //other wise move to next widget
      moveNextWidget(response);
    }
  };


  const moveToNextWidgetForSecondHolder = (response) => {
    var moveToFistHolderWidgetName = null;
    switch (currentWidget.widgetShortName) {
      case WidgetEnum.PERSONALINFO:
        if(response && response.isKycProcessCompleted){
          moveToFistHolderWidgetName =WidgetEnum.PVIEWCKYC;
        }else{
          moveToFistHolderWidgetName =WidgetEnum.PERSONALINFO;
        }    
        break;
      case WidgetEnum.ESIGNTC:
        if (checkFirstHolderHasVideoKYC()){
         moveToFistHolderWidgetName = WidgetEnum.VIDEOKYC;
        }
       
        break;
      default:
        break;
    }

    if (moveToFistHolderWidgetName) {
      applicationContext.setCurrentWidget(null);
      setTimeout(() => {
        applicationContext.setWidgetShortNameToShow(moveToFistHolderWidgetName);
        applicationContext.setCurrentHolder(
          getHolderDataByType(EntityTypeEnum.FH)
        );
      }, 5);
 
    } else {
      //other wise move to next widget
      moveNextWidget(response);
    }
  };

 
  const getHolderDataByType=(entityTypeShortName)=>{
    return  _.find(
      holderList,
      (holder) => holder.entityTypeShortName === entityTypeShortName
    );
  }

  /**
   * check current widget was last entry widget first holder based on then workflow
   * @returns 
   */
  const checkFirstHolderLastEntryWidget=()=>{
    //check all widget data has field then return false
    if(isKycProcessCompleted) return false;
    //let currentWorkflow = applicationContext.currentWorkflow;
    if(currentHolder.entityTypeShortName === EntityTypeEnum.FH && currentWidget.widgetShortName===WidgetEnum.BANKVF){
        return true;
      }
      else{
        return false;
      }
  }

  /**
   * check current widget was last entry widget second holder based on then workflow
   * @returns 
   */
  const checkSecondHolderLastEntryWidget=()=>{
    let currentWorkflow = applicationContext.currentWorkflow;
    if(currentHolder.entityTypeShortName === EntityTypeEnum.SH && currentWidget.widgetShortName===WidgetEnum.PERSONALINFO){
        return true;
      }
      else{
        return false;
      }
  }

  function moveNextWidget(response) {
    let widget = _.find(
      widgetList,
      (widget) => widget.displayIndex === currentWidget.displayIndex + 1
    );

    // if move to the preview widget then check kyc prcoess complete then move otherwise not
    if(response!=null  && response.isKycProcessCompleted ===false && widget && widget.widgetShortName===WidgetEnum.PVIEWCKYC){
      return;
    }

    if (widget) {
      applicationContext.setCurrentWidget(widget);
    }
  }


  function moveNextWidgetByName(widgetShortName) {
    let widget = _.find(
      widgetList,
      (widget) => widget.widgetShortName === widgetShortName
    );

    if (widget) {
      applicationContext.setCurrentWidget(widget);
    }

    return widget;
  }

  /** Move to the previous widget */
  const moveToPreviousWidget = () => {
      if(currentHolder.entityTypeShortName === EntityTypeEnum.FH 
        && currentWidget.widgetShortName===WidgetEnum.VIDEOKYC){
          moveNextWidgetByName(WidgetEnum.BANKVF);
      }else if(currentHolder.entityTypeShortName === EntityTypeEnum.SH 
        && currentWidget.widgetShortName===WidgetEnum.VIDEOKYC){
          moveNextWidgetByName(WidgetEnum.PERSONALINFO);
      }else{
        let widget = _.find(
          widgetList,
          (widget) => widget.displayIndex === currentWidget.displayIndex - 1
        );
        if (widget) {
          applicationContext.setCurrentWidget(widget);
        }
    }
  };

  return (
    <>
      {currentHolder && currentHolder.entityTypeShortName && holderData && (
        <div>{_renderWidget(currentWidget)}</div>
      )}
    </>
  );

}

export default WidgetManager;
